import React, {useState} from 'react'
import Architecture from '../../../../assets/Architecture.svg'
import { Dialog } from 'primereact/dialog';
import './style.css'

const Projects = () => {

	const [imageDialog, setImageDialog] = useState(false);

	return (
		<div className="projects p-card">
			<div className='header'>
				<h3>K8s Resume </h3>
				<a href={'https://gitlab.com/default8792837/K8s-Resume'} target="_blank" rel="noopener noreferrer">
				<p><strong>GitLab Link</strong></p>
				</a>
			</div>
			<p>
				A project where I aimed to move my
				<a href={'https://cv.gvasilopoulos.xyz'} target="_blank" rel="noopener noreferrer"> Resume </a>
				from AWS (see<a href={'https://gitlab.com/default8792837/Serverless-Website-AWS-Terraform'} target="_blank" rel="noopener noreferrer"> this project</a>)
                to my K8s cluster
			</p>
			<p id="title">Architecture diagram:</p>
			<div className="image-container">
				<img
					onClick={() => setImageDialog(true)}
					src={Architecture}
					alt="Architecture"
				/>
			</div>
			<p id="title">Deployment:</p>
			<p> 1. The pipeline builds the images and pushes them to the registry, using kaniko </p>
			<p> 
				2. Opens an MR on the <a href={'https://gitlab.com/kubernetes4093238/prod-cluster-gitops'} target="_blank" rel="noopener noreferrer"> GitOps repo</a>, modifying the image version for the deployments
			</p>
			<p> 3. FluxCD pulls the changes and applies the updated resources </p>
			<p id="title">Description:</p>
			<p> 
				1. For the Database I used the PostgreSQL v15.3.0 non HA chart from <a href={'https://github.com/bitnami/charts/tree/main/bitnami/postgresql'} target="_blank" rel="noopener noreferrer"> Bitnami</a><br />
			    <ul>
				    <li>
					    Being the stateful component of the application, it required persistent storage, which was provisioned locally using <a href={'https://github.com/openebs/openebs'} target="_blank" rel="noopener noreferrer"> OpenEBS</a><br />
				    </li>
				    <li>
					    A database and a user with the required permissions were created using psql
				    </li>
			    </ul>

			</p>
			<p>
				2. For the Backend I wrote a simple Django API (ChatGPT helped a lot) with two endpoints: read/ and write/<br />
				<ul>
					<li>
						The first one reads the value from the DB and returns it and the second one, increments the value in the DB by 1 and returns the new value<br />
					</li>
					<li>
						The communication with the DB is established using the <a href={'https://www.psycopg.org/docs/'} target="_blank" rel="noopener noreferrer"> psycopg2 adapter</a>
					</li>
				</ul>
			</p>
			<p>
				3. The Frontend was created using React and contains a visitor counter. The function:<br />
				<ul>
					<li>
						Checks the local storage for the value and if it doesn’t exist it, calls the backend write endpoint<br />
					</li>
					<li>
						If the value already exists in local storage (the website has already been visited), calls the backend read endpoint to update the locally stored value
					</li>
				</ul>
			</p>
			<p>
				4. To expose the application, without a static IP, I used:<br />
				<ul>
					<li>
						<a href={'https://github.com/metallb/metallb'} target="_blank" rel="noopener noreferrer"> MetalLB</a> - To assign IPs to services of Type LoadBalancer, that are private and routable on my LAN<br />
					</li>
					<li>
						<a href={'https://github.com/kubernetes/ingress-nginx'} target="_blank" rel="noopener noreferrer"> Ingress Nginx</a> with Type LoadBalancer<br />
					</li>
					<li>
						<a href={'https://github.com/crazy-max/ddns-route53/'} target="_blank" rel="noopener noreferrer"> ddns-route53</a> to keep my DNS records in sync with my public IP<br />
					</li>
					<li>
						Port Forward pubic 443 to Ingress
					</li>
				</ul>
			</p>
			<p>
				5. For the TLS certificates I used <a href={'https://github.com/cert-manager/cert-manager'} target="_blank" rel="noopener noreferrer"> cert-manager</a> installed using their provided helm chart, <a href={'https://letsencrypt.org/'} target="_blank" rel="noopener noreferrer"> let's encrypt</a> issuer and the DNS challenge
			</p>
			<p id="title">Disclaimer:</p>
			<p>The Frontend was not created by me. All credits go to Nick Vasilopoulos</p>
			<Dialog className="architecture-diagram-dialog" header="Architecture diagram" visible={imageDialog} onHide={() => setImageDialog(false)}>
				<img
					src={Architecture}
					alt="Architecture"
				/>
			</Dialog>
		</div>
	)
}

export default Projects
